import { GUI } from "dat.gui";
import { Mesh, TextureLoader } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/tema6/GLB_Celular.glb";
import { textureAct } from "../../../../../assets/tema6/act";


const textureMaterial = {
	topic3_act1_01: textureAct.topic3_act_1.Phone_1,

	topic3_act2_02: textureAct.topic3_act_2.Phone_2,
	topic3_act2_03: textureAct.topic3_act_2.Phone_3,
	topic3_act2_04: textureAct.topic3_act_2.Phone_4,
	topic3_act2_05: textureAct.topic3_act_2.Phone_5,
	topic3_act2_06: textureAct.topic3_act_2.Phone_6,

	topic3_act3_01: textureAct.topic3_act_3.Phone_quiz_1,
	topic3_act3_02: textureAct.topic3_act_3.Phone_quiz_2,
	topic3_act3_03: textureAct.topic3_act_3.Phone_quiz_3,

	topic5: textureAct.topic5.Phone_Spin,
}

export class Phone extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(5, 5, 5)
		// this.helpers()

		this.namesTextures = {
			"topic3_act1_01": "topic3_act1_01",

			"topic3_act2_02": "topic3_act2_02",
			"topic3_act2_03": "topic3_act2_03",
			"topic3_act2_04": "topic3_act2_04",
			"topic3_act2_05": "topic3_act2_05",
			"topic3_act2_06": "topic3_act2_06",

			"topic3_act3_01": "topic3_act3_01",
			"topic3_act3_02": "topic3_act3_02",
			"topic3_act3_03": "topic3_act3_03",

			"topic5": "topic5",
		}
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Celular = gltf.scene.getObjectByName("Celular", true);
			this.CelularPantalla = gltf.scene.getObjectByName("CelularPantalla", true);

			this.selectTexture(this.namesTextures.topic3_act1_01);
		});
	}

	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.CelularPantalla;
		object.material.map = newTexture
		object.material.toneMapped = true;
	}

	selectTexture(step = "") {
		const img = textureMaterial[step]
		if (!img) {
			return
		}
		this.updateMaterialScreen(img)
	}
	helpers() {
		const gui = new GUI();
		const folderPhone = gui.addFolder("Phone");
		const limit = 20;
		folderPhone.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderPhone.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderPhone.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderPhone.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderPhone.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderPhone.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderPhone.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderPhone.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderPhone.add(this, "visible").name("Visible");
	}
}
